import { render, staticRenderFns } from "./cooDashboard.vue?vue&type=template&id=41e6ebe6&scoped=true"
import script from "./cooDashboard.vue?vue&type=script&lang=js"
export * from "./cooDashboard.vue?vue&type=script&lang=js"
import style0 from "./cooDashboard.vue?vue&type=style&index=0&id=41e6ebe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e6ebe6",
  null
  
)

export default component.exports